const LISTING_POST_STATES = {
  ENABLED: 'enabled',
  DISABLED: 'disabled',
};

export { LISTING_POST_STATES };
